import React from 'react';
import { Link } from 'react-router-dom';
import AzulejoPanel from '../AzulejoPanel';
import PinPolaroid from '../PinPolaroid';
import PetIllustration from '../PetIllustration';
import PetGallery from '../PetGallery';
import WatercolorWash from '../WatercolorWash';
import { formatAgePt } from '../../api/petAdapter';
import type { Pet } from '../../types';
import '../../styles/DetailHero.css';

interface DetailHeroProps {
  pet: Pet;
}

const DetailHero: React.FC<DetailHeroProps> = ({ pet }) => {
  const back =
    pet.kind === 'cat'
      ? { to: '/adotar/gatos', label: '← voltar aos gatos' }
      : { to: '/adotar/caes', label: '← voltar aos cães' };

  return (
    <section className="detail-hero">
      <WatercolorWash
        variant="a"
        color="#c68c3b"
        style={{ top: '-80px', right: '-80px' }}
      />

      <div className="detail-hero__copy rise">
        <Link to={back.to} className="detail-hero__back">{back.label}</Link>

        <div className="detail-hero__chapter">Cap. V · Ficha {pet.ref}</div>
        <div className="detail-hero__tag">{pet.tag}</div>

        <h1 className="detail-hero__name">{pet.name}</h1>

        <p className="detail-hero__line">{pet.line}</p>

        <dl className="detail-hero__meta">
          <div>
            <dt>Idade</dt>
            <dd>{formatAgePt(pet.ageMonths) ?? '—'}</dd>
          </div>
          <div>
            <dt>Sexo</dt>
            <dd>{pet.genderLabel}</dd>
          </div>
          {pet.energyLabel && (
            <div>
              <dt>Energia</dt>
              <dd>{pet.energyLabel}</dd>
            </div>
          )}
        </dl>

        <a className="btn btn--primary detail-hero__cta" href="#contact-pet">
          Quero conhecer {pet.kind === 'cat' ? 'a' : 'o'} {pet.name} →
        </a>
      </div>

      <div className="detail-hero__visual">
        {pet.photoUrls.length > 0 ? (
          <PetGallery pet={pet} />
        ) : (
          <div className="detail-hero__azulejo">
            <AzulejoPanel stamp={`Silvalde · Ficha ${pet.ref}`} />
            <div className="detail-hero__pin">
              <PinPolaroid
                variant="hero"
                caption={pet.name}
                badge={pet.badge}
                tapeColor={pet.tapeColor}
                media={
                  <PetIllustration
                    kind={pet.illustration.kind}
                    variant={pet.illustration.variant}
                    palette={pet.illustration.palette}
                  />
                }
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default DetailHero;
